import Header from "../components/Header";
import style from "./home.module.css";
import ContentComponent from "../components/contentComponent";
import SideBarComponent from "../components/sideBarComponent";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Home() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        const pathname = window.location.pathname;
        setActiveTab(pathname);
    }, [location.pathname]);

    return (
        <div className={style.container}>
            <div className={style.header}>
                <Header />
            </div>
            <div className={activeTab === '/chat-panel' ? style.mainWrapper2 : style.mainWrapper}>
                <SideBarComponent />
                <ContentComponent />
            </div>
        </div>
    );
}

export default Home;